import React, { useState, useEffect } from 'react';
import '../styles/About.css';

const timelineData = [
  {
    year: '2020',
    title: 'University of Missouri - Division of IT - Tiger Response Team',
    description: [
      'Responded to ticket escalations and monitored incoming tickets.',
      'Communicated with Technical Dispatchers.',
      'Prepared systems for deployment on multiple operating systems.'
    ]
  },
  {
    year: '2022',
    title: 'True Manufacturing Company',
    description: [
      'Help Desk Analyst Co-Op',
      'Fielded incoming support requests from end users via telephone and email.',
      'Troubleshooted and resolved issues related to operating systems and applications.',
      'Worked alongside teams to solve computer related issues.',
      'Promoted to Application Developer Intern Remote.',
      'Worked with C#, HTML, ASP.NET, SQL, and Visual Studio to update in house applications.',
      'Effectively communicated in Agile and Scrum daily standup meetings.',
      'Completed technical documentation, unit testing, and change control processes.',
      'Used SSRS to generate reports for business and manufacturing use cases.'
    ]
  },
  {
    year: '2023',
    title: 'Graduated Mizzou College of Engineering with a B.S. in Information Technology',
    description: [
      "Started Infrastructure internship at O'Reilly Auto Parts",
      'Gained hands-on experience with Linux system administration.',
      'Focusoed on  bash, shell scripting, python, puppet automation, and networking fundamentals.',
    ]
  },
  {
    year: '2025',
    title: "O'Reilly Auto Part's",
    description: [
      'DevOps Linux System Administrator.',
      'Managing large scale Linux servers.',
      'Implementing automation solutions.',
      'Managing vulnerabilities and compliance.',
      'Use advanced monitoring tools.',
      'Hidden Gem award for delivering work with quality and consistency.',
      'You Rock! award for going above and beyond.'
    ]
  }
];

const About = () => {
  const [activeYear, setActiveYear] = useState(null);
  const [currentText, setCurrentText] = useState('');
  const [currentLine, setCurrentLine] = useState(0);
  const [showCursor, setShowCursor] = useState(true);
  const [isBoxActive, setIsBoxActive] = useState(false);
  const [buttonText, setButtonText] = useState('> INITIATE RESUME DOWNLOAD');
  const [isDownloading, setIsDownloading] = useState(false);
  const [showProgress, setShowProgress] = useState(false);
  const [progress, setProgress] = useState(0);
  const [titleText, setTitleText] = useState('');
  const [showTitleCursor, setShowTitleCursor] = useState(true);
  const [showContent, setShowContent] = useState(false);

  // Title typing animation
  useEffect(() => {
    const title = "My Journey";
    let currentIndex = 0;

    const typeTitle = () => {
      if (currentIndex < title.length) {
        setTitleText(title.substring(0, currentIndex + 1));
        currentIndex++;
        setTimeout(typeTitle, 150);
      } else {
        setTimeout(() => {
          setShowTitleCursor(false);
          setShowContent(true);
        }, 1000);
      }
    };

    typeTitle();
  }, []);

  const handleTimelineClick = (index) => {
    if (activeYear === index) {
      setActiveYear(null);
      setIsBoxActive(false);
      setCurrentText('');
      setCurrentLine(0);
    } else {
      setActiveYear(index);
      setIsBoxActive(true);
      setCurrentText('');
      setCurrentLine(0);
    }
  };

  const handleDownload = () => {
    setIsDownloading(true);
    setShowProgress(true);
    setButtonText('> DOWNLOADING [██████████]');
    setProgress(0);

    // Create a link element
    const link = document.createElement('a');
    link.href = '/Michael_Shamsutdinov_Resume 2025.pdf'; // Exact filename from public folder
    link.download = 'Michael_Shamsutdinov_Resume_2025.pdf'; // This will be the downloaded file name
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    // Simulate progress for visual effect
    const interval = setInterval(() => {
      setProgress(prev => {
        if (prev >= 100) {
          clearInterval(interval);
          setButtonText('> DOWNLOAD COMPLETE');
          setTimeout(() => {
            setButtonText('> INITIATE RESUME DOWNLOAD');
            setIsDownloading(false);
            setShowProgress(false);
          }, 2000);
          return 100;
        }
        return prev + 10;
      });
    }, 50);
  };

  useEffect(() => {
    if (activeYear === null) {
      setCurrentText('');
      setCurrentLine(0);
      setIsBoxActive(false);
      return;
    }

    const lines = timelineData[activeYear]?.description || [];
    if (currentLine >= lines.length) {
      return;
    }

    const interval = setInterval(() => {
      setCurrentText(prev => {
        if (prev.length < lines[currentLine].length) {
          return prev + lines[currentLine][prev.length];
        } else {
          clearInterval(interval);
          setCurrentLine(prev => prev + 1);
          return '';
        }
      });
    }, 50);

    return () => clearInterval(interval);
  }, [activeYear, currentLine]);

  useEffect(() => {
    const cursorInterval = setInterval(() => {
      setShowCursor(prev => !prev);
    }, 500);

    return () => clearInterval(cursorInterval);
  }, []);

  return (
    <section className="about-section">
      <div className="terminal-window">
        <div className="terminal-header">
          <div className="terminal-controls">
            <span className="control close"></span>
            <span className="control minimize"></span>
            <span className="control maximize"></span>
          </div>
          <div className="terminal-title">about_me.exe</div>
        </div>
        <div className="terminal-body">
          <h1 className="about-title">
            {titleText}
            {showTitleCursor && <span className="title-cursor">_</span>}
          </h1>
          {showContent && (
            <>
              <div className="timeline-container">
                <div className="timeline">
                  {timelineData.map((item, index) => (
                    <div 
                      key={index}
                      className={`timeline-dot ${activeYear === index ? 'active' : ''}`}
                      onClick={() => handleTimelineClick(index)}
                    >
                      <div className="dot"></div>
                      <div className="year-label">{item.year}</div>
                    </div>
                  ))}
                </div>
                <div className="timeline-content">
                  {activeYear !== null && timelineData[activeYear] && (
                    <div className={`content-box ${isBoxActive ? 'active' : ''}`}>
                      <h2>{timelineData[activeYear].title}</h2>
                      <div className="typing-container">
                        {timelineData[activeYear].description.map((line, idx) => (
                          <div key={idx} className="typing-line">
                            {idx < currentLine ? (
                              <div className="completed-line">
                                <span className="prompt">{'>'}</span> {line}
                              </div>
                            ) : idx === currentLine ? (
                              <div className="typing-text">
                                <span className="prompt">{'>'}</span> {currentText}
                                {showCursor && <span className="cursor"></span>}
                              </div>
                            ) : null}
                          </div>
                        ))}
                      </div>
                    </div>
                  )}
                </div>
              </div>
              <div className="download-container">
                <div className="command-line">
                  <span className="prompt">$</span>
                  <button 
                    className={`download-btn ${isDownloading ? 'downloading' : ''}`}
                    onClick={handleDownload}
                    disabled={isDownloading}
                  >
                    <span className="btn-text">{buttonText}</span>
                    {!isDownloading && <span className="btn-cursor">_</span>}
                  </button>
                </div>
                {showProgress && (
                  <div className="progress-container">
                    <div className="progress-bar" style={{ width: `${progress}%` }}></div>
                    <div className="progress-text">{progress}%</div>
                  </div>
                )}
              </div>
            </>
          )}
        </div>
      </div>
    </section>
  );
};

export default About; 